/**
 * STY-730: read each dropped file on its own.
 *
 * Every file is decoded in an <img> to read its width. The old code ran that
 * through Promise.all with no catch, so one file the browser can't decode
 * (HEIC in Chrome/Firefox, TIFF, a corrupt JPG) rejected the whole batch and
 * nothing uploaded -- silently. Now only that file is rejected, with a
 * message telling the vendor what to do.
 */
export const UNREADABLE_FILE_REASON = "couldn't be read by your browser. Please export it as a JPG and upload it again."

export function readDroppedFiles (files, readOne) {
  return Promise.all(files.map((file) =>
    Promise.resolve()
      .then(() => readOne(file))
      .then(
        (read) => ({ read }),
        () => ({ read: Object.assign(file, { valid: false, reason: UNREADABLE_FILE_REASON }) })
      )
  )).then((results) => {
    const valid = []
    const rejected = []
    results.forEach(({ read }) => {
      if (read && read.valid) valid.push(read)
      else rejected.push(read)
    })
    return { valid, rejected }
  })
}
